<template>
  <div class="footer">
    <div class="footer-text">
      Copyright © 2022-2023 917.cn 版权所有 保留一切权利 
      备案号:
      <a href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备20014711号-4</a>
    </div>
    <div class="beian">
      <a
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51110202000407"
        class="beian-gongan"
        >
        <img src="@/assets/images/icons/beian.png" class="beian-gongan-image"/>
        <span class="beian-gongan-text">川公网安备 51110202000407号</span>
        </a>
        <router-link class="beian-icp" target="_blank" :to="{name: 'icp'}">经营性网站备案信息</router-link>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    onOpenIcp() {
      this.$router.push({name: 'icp'})
    }
  }
};
</script>

<style lang="scss" scoped>
.footer {
		margin: 50px auto;
		font-size: 14px;
		color: #666666;
		a {
			color: #666666;
			text-decoration: none;
		}
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		.footer-text {
			display: flex;
			flex-direction: row;
		}
		.beian {
      cursor: pointer;
			margin-top: 30px;
			display: flex;
			flex-direction: row;
			.beian-gongan {
				display: flex;
				flex-direction: row;
				align-items: center;
				.beian-gongan-image {
					width: 16px;
					height: 16px;
				}
			}
			.beian-icp {
        cursor: pointer;
				margin-left: 20px;
			}
		}
	}
</style>
